import React, { useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckout from "../components/StripeCheckout";
import { useSelector, useDispatch } from "react-redux";
import { useSpring, animated } from 'react-spring';
import { CreditCardFilled } from "@ant-design/icons";
import { toast } from "react-toastify";
import { createBookedPaymentIntent } from "../functions/stripe";

// load stripe outside of components render to avoid recreating stripe object on every render
// const promise = loadStripe("pk_test_51Io7B5SAtCMk2QKCajAOR8EFYgaamUKCZMVoAMIEzasL4KbgC5E8mlFtai4KWkwfoSXSray4OX1PQkaoMfKXGLnQ00yAx61uJx");
const promise = loadStripe(`pk_live_51Io7B5SAtCMk2QKCQEDQG6fOu2GsdYaOTND3SQjUvUigrVBxOSaHXA6P9INtYX0B62V2dxWnPA9hBPeUJ3U25T1u00bAmU6ces`,
  { betas: ['upi_beta_1'] }
);

const Payment = ({ point, checked, coupon, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId, paymentMode, shippingPrice, products, packing, currencyMultiplier, currency }) => {

  const { x } = useSpring({ loop: true, from: { x: 0 }, x: 1, config: { duration: 1000 } })

  const { user } = useSelector((state) => ({ ...state }));


  // useEffect(() => {
  //   if (paymentMode != 'only-card' && user) {
  //     createBookedPaymentIntent(user.token, { paymentMode, point, checked, coupon, shipping, deliveryType, pickupStore, dispatchStore, storeNumber, expressShipping, specialId })
  //       .then((res) => {
  //         console.log(res.data);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         // if (err.response.status === 400) toast.error(err.response.data);
  //         toast.error(err.response.data.err);
  //       });
  //   }
  // }, [])

  return (
    <div className="container p-5 text-center">
      <h4>Complete your purchase</h4>
      <Elements stripe={promise}>
        <div className="col-md-8 offset-md-2">
          {/* {paymentMode == 'only-card' ? (
            <StripeCheckout point={point} checked={checked} coupon1={coupon} shipping={shipping} deliveryType={deliveryType} pickupStore={pickupStore} dispatchStore={dispatchStore} storeNumber={storeNumber} expressShipping={expressShipping} specialId={specialId} />
          ) : (
              <animated.div
                style={{
                  opacity: x.interpolate({ range: [0, 5], output: [1, 4] }),
                  transform: x
                    .interpolate({
                      range: [0, 0.25, 0.35, 0.45, 0.55, 0.65, 0.75, 1],
                      output: [1, 0.97, 0.9, 1.1, 0.9, 1.1, 1.03, 1]
                    })
                    .interpolate(x => `scale(${x})`)
                }}>
                <CreditCardFilled style={{ fontSize: 100, width: 100 }} />
              </animated.div>
            )} */}
            <StripeCheckout point={point} checked={checked} coupon1={coupon} shipping={shipping} deliveryType={deliveryType} pickupStore={pickupStore} dispatchStore={dispatchStore} storeNumber={storeNumber} expressShipping={expressShipping} specialId={specialId} shippingPrice={shippingPrice} products={products} packing={packing} currencyMultiplier={currencyMultiplier} currency={currency} />

        </div>
      </Elements>
      <div>
        <p className="form_encryption"><span className="button_icon" /></p><div className="vector-icon-size--large"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Lock Icon" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className="vector-icon-color--second"><title lang="en">Lock Icon</title><desc /><g fill stroke><g><path d="M22.8 12.9v-1c0-3.5-2.8-6.3-6.3-6.3s-6.3 2.8-6.3 6.3v1c-1.2 0.1-2.2 1.1-2.2 2.4v6.7c0 2.4 2 4.4 4.4 4.4h8.1c2.4 0 4.4-2 4.4-4.4v-6.8c0.1-1.2-0.9-2.2-2.1-2.3zM16.5 7.5c2.4 0 4.3 1.9 4.3 4.3v1h-8.7v-1c0.1-2.3 2-4.3 4.4-4.3zM23 22c0 1.3-1.1 2.4-2.4 2.4h-8.1c-1.3 0-2.4-1.1-2.4-2.4v-6.8c0-0.2 0.2-0.4 0.4-0.4h12.1c0.2 0 0.4 0.2 0.4 0.4v6.8z" /><path d="M16.5 17.8c-0.7 0-1.3 0.6-1.3 1.3 0 0.4 0.2 0.8 0.6 1v1.1c0 0.2 0.2 0.4 0.4 0.4h0.5c0.2 0 0.4-0.2 0.4-0.4v-1.1c0.3-0.2 0.6-0.6 0.6-1 0.1-0.8-0.5-1.3-1.2-1.3z" /></g></g></svg></div> This is a secure 256-bit SSL encrypted payment
  <p />
      </div>

    </div>
  );
};

export default Payment;
